import {Component, EventEmitter, Input} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {NotificationService} from "../../atoms/notification/notification.service";

@Component({
  selector: 'brt-share-overlay',
  templateUrl: './share-overlay.component.html',
  styleUrls: ['./share-overlay.component.scss']
})
export class ShareOverlayComponent implements Overlayable{
  // @Input('url') url: string = window.location.href;
  @Input('url') url: string = window.location.href;
  onClosed = new EventEmitter<boolean>();
  isLinkCopied = false;

  subject = "Berufsreise"
  text = "Schau, was ich auf berufsreise.at gefunden habe! ";

  // facebook link: https://stackoverflow.com/questions/20956229/has-facebook-sharer-php-changed-to-no-longer-accept-detailed-parameters

  constructor(private notification: NotificationService) {
  }
  copyShareLinkToClipboard() {
    window.navigator.clipboard.writeText(this.url).then(() => {
      this.isLinkCopied = true;

      setTimeout(() => {
        this.isLinkCopied = false;
      }, 3000);
    }).catch((err) => {console.log(err)});
  }
}
